import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TikTokFilledSvg from "@ant-design/icons-svg/es/asn/TikTokFilled";
import AntdIcon from '../components/AntdIcon';
var TikTokFilled = function TikTokFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: TikTokFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(TikTokFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'TikTokFilled';
}
export default RefIcon;